/** The single boundary between asynchronous results and visible account state. */
export interface Publication {
  readonly accountId: string;
  readonly session: number;
  readonly destination?: number;
}

export class PublicationCoordinator {
  #accountId = "";
  #session = 0;
  #destination = 0;

  activate(accountId: string): Publication {
    this.#accountId = accountId;
    this.#session++;
    this.#destination++;
    return this.capture();
  }
  end(): void { this.activate(""); }
  navigate(): void { this.#destination++; }
  capture(destination = false): Publication {
    return { accountId: this.#accountId, session: this.#session,
      ...(destination ? { destination: this.#destination } : {}) };
  }
  current(snapshot: Publication): boolean {
    return Boolean(this.#accountId) && snapshot.accountId === this.#accountId
      && snapshot.session === this.#session
      && (snapshot.destination === undefined || snapshot.destination === this.#destination);
  }
  publish(snapshot: Publication, commit: () => void): boolean {
    if (!this.current(snapshot)) return false;
    commit();
    return true;
  }
}
